import { defineComponent } from 'vue';
import HomeHeaderMobileLink from '@/components/layout/header/header-mobile/HeaderMobileLink.vue';
export default defineComponent({
    components: {
        HomeHeaderMobileLink
    }
});
